import { useEffect } from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useOrganization } from '@/context/organization-context';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/client/brand/$clientId')({
  component: ClientDetailLayout,
});

function ClientDetailLayout() {
  const { clientId } = Route.useParams();
  const { activeClient, switchClient } = useOrganization();

  // Ensure the active client matches the URL param
  useEffect(() => {
    if (clientId && activeClient?.id !== clientId) {
      switchClient(clientId);
    }
  }, [clientId, activeClient?.id, switchClient]);

  return <Outlet />;
}
